<template>
  <v-card
    outlined
    class="customer-count-card"
    @click="$router.push({ path: '/customer/list' })"
  >
    <v-card-text class="pa-4">
      <div class="d-flex align-start justify-space-between">
        <div>
          <div class="stat-title">Customers</div>
          <div class="stat-subtitle">Total customer count</div>
        </div>

        <v-avatar color="blue" size="42">
          <v-icon dark>mdi-account-group</v-icon>
        </v-avatar>
      </div>

      <div class="mt-5">
        <v-skeleton-loader
          v-if="isLoading"
          type="text"
          max-width="120"
        />

        <animated-number
          v-else
          class="stat-value"
          :value="amount"
          :formatValue="formatToNumber"
          :duration="1000"
        />
      </div>
      
    </v-card-text>
  </v-card>
</template>

<script>
import customerService from "../../service";
import AnimatedNumber from "animated-number-vue";

export default {
  name: "CustomerCount",

  components: {
    AnimatedNumber,
  },

  data() {
    return {
      isLoading: true,
      amount: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    formatToNumber(value) {
      return `${value.toFixed(0)}`;
    },

    loadData() {
      customerService.getAll({ limit: 1 }).then((response) => {
        this.amount = response.count || 0;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.customer-count-card {
  border-radius: 20px;
  min-height: 150px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
}

.customer-count-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.stat-title {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

.stat-subtitle {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

.stat-value {
  display: block;
  font-size: 34px;
  line-height: 1.1;
  font-weight: 700;
  color: #0f172a;
}

.stat-footer {
  font-size: 12px;
  color: #64748b;
}
</style>